import React from 'react';

const HomeLandingCarousel = () => {
  return (
    <>
      <section id="home" className="hero">
        <div className="hero-inner">
          <div className="hero-content">
            <span className="hero-eyebrow">Outcome-Driven IT Solutions</span>

            <h1>
              Stop Managing Tech.
              <br />
              <span>Start Outpacing Your Competition.</span>
            </h1>

            <p>
              We build custom software, modernize your cloud infrastructure, and provide top-tier talent so you can focus on growing your business, not fixing your IT.
            </p>

            <div className="hero-actions">
              <a className="hero-cta hero-cta-primary" href="#contact">
                Get a Free Consultation
              </a>
              <a className="hero-cta hero-cta-secondary" href="#services">
                See Our Solutions
              </a>
            </div>
          </div>

          <div className="hero-media">
            <img
              src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
              alt="Team collaborating on technology solutions"
            />
          </div>
        </div>
      </section>

      <section className="social-proof" aria-label="Company trust statement">
        <p>Serving businesses from startups to enterprises with secure software, cloud, data, and staffing support.</p>
        <div className="proof-points">
          <span>Custom Software</span>
          <span>Cloud Modernization</span>
          <span>Specialist Staffing</span>
          <span>Data & AI Enablement</span>
        </div>
      </section>
    </>
  );
};

export default HomeLandingCarousel;
